import { FC, useEffect, useRef } from 'react'
import styled from 'styled-components'

import { IconPack } from '@/components/cell/atoms/Icon/enum'
import Badge from '@/components/cell/molecules/Badge'

interface ContainerProps {}
const Container = styled.div<ContainerProps>`
  // TODO : 너비 넘어가는 뱃지부터 생략하고, 몇개 더 있는지 숫자로 표시하는 기능 구현하기
  overflow-x: hidden;
  white-space: nowrap;
  & div {
    width: 100%;
  }
  & div > [class^='Badge'] {
    margin-right: 8px;
    text-align: center;
  }
  & div > [class^='Badge'].dot ~ [class^='Badge'] {
    display: none;
  }
`

const setTagDot = (wrapper: HTMLDivElement, tags: string[]) => {
  const width = wrapper.clientWidth
  let sum = 0
  let lastIndex = -1
  const margin = 8

  // 기존값 복구
  for (let i = 0; i < wrapper.children.length; i++) {
    const tag = wrapper.children[i] as HTMLSpanElement
    if (tag.classList.contains('dot')) {
      tag.classList.remove('dot')
      const text = tag.children[0] as HTMLSpanElement
      text.innerText = tags[i]
    }
  }

  // 마지막 보이는 태그 찾기
  for (let i = 0; i < wrapper.children.length; i++) {
    const tag = wrapper.children[i] as HTMLSpanElement
    if (margin + tag.clientWidth + sum > width) {
      lastIndex = i - 1
      break
    }
    sum += margin + tag.clientWidth
  }

  // 선택된 태그가 없으면 종료
  if (lastIndex < 0) {
    return
  }

  // 마지막 보이는 태그에 작업
  const lastTag = wrapper.children[lastIndex] as HTMLSpanElement
  lastTag.classList.add('dot')
  const text = lastTag.children[0] as HTMLSpanElement
  text.innerText = '+' + (tags.length - lastIndex)
}

interface Props {
  tags?: string[] | null
  icon?: IconPack
  color?: 'gray' | 'orange' | 'yellow'
}
const TagList: FC<Props> = ({ tags, icon, color }) => {
  const wrapper = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const callback = () => {
      if (process.browser && wrapper.current !== null && tags && tags.length) {
        setTagDot(wrapper.current, tags)
      }
    }
    window.addEventListener('resize', callback)
    callback()

    return () => {
      window.removeEventListener('resize', callback)
    }
  }, [tags])

  return (
    <Container>
      <div ref={wrapper}>
        {tags?.map((tag, index) => (
          <Badge key={index} beforeIcon={icon} color={color}>
            {tag}
          </Badge>
        ))}
      </div>
    </Container>
  )
}

export default TagList
